import React from 'react';
import { Typography } from '@material-ui/core';

import { Button } from 'ui';

import { useTileStyles } from './DashboardTile.styles';
import { DashboardTileProps } from './dashboardTile.types';

export const DashboardTile = ({ icon: Icon, number, title, onClick, color }: DashboardTileProps) => {
  const classes = useTileStyles({ color });
  return (
    <div className={classes.container}>
      <Icon className={classes.icon} />
      <Typography className={classes.number}>{number}</Typography>
      <Typography className={classes.subtitle}>{title}</Typography>
      <Button onClick={onClick} className={classes.button} variant="outlined" color="primary">
        Show all
      </Button>
    </div>
  );
};
